import { FlaskConical, FileStack, Factory, Package, ScrollText, RefreshCcw } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal, SectionHeader } from "./Reveal";

const services = [
  { icon: FlaskConical, title: "Custom Formula Development", text: "Original formulations built from scratch around your brief, benchmarks and target cost.", href: "/cosmetic-formulation-development" },
  { icon: FileStack, title: "Stock Formulas", text: "A curated library of proven, ready-to-launch formulas for the fastest possible market entry.", href: "/private-label-cosmetics-india" },
  { icon: Factory, title: "Manufacturing Coordination", text: "Introductions to vetted manufacturers and hands-on tech transfer of your formula.", href: "/cosmetic-manufacturing-support" },
  { icon: Package, title: "Packaging Guidance", text: "Compatibility testing, component selection and shelf-presence advice.", href: "/cosmetic-manufacturing-support" },
  { icon: ScrollText, title: "Regulatory Support", text: "Label review, claims guidance and documentation for domestic and export compliance.", href: "/regulatory-testing-support" },
  { icon: RefreshCcw, title: "Reformulation", text: "Improving cost, stability, texture or compliance of your existing products.", href: "/services" },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-24 lg:py-32 bg-navy text-ivory scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <SectionHeader light overline="Our Services" title={<>Everything between <em className="italic font-medium">idea and launch.</em></>} />
        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-ivory/10 border border-ivory/10 rounded-xl overflow-hidden">
          {services.map(({ icon: Icon, title, text, href }, i) => (
            <Reveal key={title} delay={(i % 3) * 0.08} className="group bg-navy transition-colors duration-300 hover:bg-[#4a5838]">
              <Link to={href} data-testid={`service-card-link-${i}`} className="block p-10 h-full" aria-label={`${title} — learn more`}>
                <Icon size={24} strokeWidth={1.5} className="text-ivory/80 transition-transform duration-300 group-hover:-translate-y-1" />
                <h3 className="mt-6 font-display text-xl text-ivory leading-snug">{title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-ivory/60">{text}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
